import React, { useState } from "react";
import { Plus } from "react-feather";
var Addon = function (_a) {
    var _b;
    var ingredient = _a.ingredient, incrementIngredient = _a.incrementIngredient, decrementIngredient = _a.decrementIngredient;
    var _c = useState(false), selected = _c[0], setSelected = _c[1];
    var toggle = function () {
        if (selected) {
            decrementIngredient();
        }
        else {
            incrementIngredient();
        }
        setSelected(!selected);
    };
    return (React.createElement("button", { key: ingredient.id, className: "addon ".concat(selected ? "selected" : ""), onClick: toggle },
        React.createElement("span", { style: { fontWeight: "700" } }, ingredient.name),
        React.createElement("img", { style: {
                minWidth: 0,
            }, src: (_b = ingredient.images.normal) !== null && _b !== void 0 ? _b : "", alt: "" }),
        React.createElement("div", { className: "toggle" },
            React.createElement(Plus, { className: "icon" }))));
};
export default Addon;
